import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";
import Avatar from "../../../components/Avatar/Avatar";

import { FaChevronLeft } from "react-icons/fa";

import { useTranslation } from "react-i18next";

function ProfilePage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [userData, setUserData] = useState();
  // NEW MEMBERSHIP BASED BADGES
  const [activeMembershipTier, setActiveMembershipTier] = useState();
  //
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      setUserData(data);
      // NEW MEMBERSHIP BASED BADGES
      setActiveMembershipTier(data.membershipTier);
      //
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // eslint-disable-next-line
  const [achievementsUnlocked, setAchievementsUnlocked] = useState();
  const fetchAchievements = async () => {
    try {
      setIsLoading(true);

      let fetchedAchievementsUnlocked = 0;

      const q = query(collection(db, "achievements"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newAchievement = doc.data();
        if (newAchievement.achieverUids.includes(user.uid)) {
          fetchedAchievementsUnlocked += 1;
        }
      });

      setAchievementsUnlocked(fetchedAchievementsUnlocked);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching achievements data");
    }
  };

  useEffect(() => {
    fetchAchievements();
    // eslint-disable-next-line
  }, []);

  const [totalChampionPoints, setTotalChampionPoints] = useState(0);

  const fetchTotalChampionPoints = async () => {
    try {
      setIsLoading(true);

      // Fetch all groups
      const groupsSnapshot = await getDocs(query(collection(db, "groups")));
      const groups = groupsSnapshot.docs.map((doc) => doc.data());

      // Fetch all rooms
      const roomsSnapshot = await getDocs(query(collection(db, "rooms")));
      const rooms = roomsSnapshot.docs.map((doc) => doc.data());

      let userPoints = 0;
      let userStarPoints = 0;

      rooms.forEach((room) => {
        // Find the current user in room.members
        const member = room.members?.find((m) => m.uid === user?.uid);
        if (!member) return;

        room?.submissions?.forEach((submission) => {
          if (submission.submitterUid === user.uid) {
            const group = groups.find((e) => e.uid === submission.groupUid);

            if (
              group?.dateCreated &&
              new Date(group.openingDateTime) >= new Date("July 1, 2025")
            ) {
              if (room?.leagueSport === "RACING") {
                if (
                  submission?.positions.firstPolePositionDriver ===
                    group?.drivers.find((e) => e.result === "firstPolePosition")
                      ?.name ||
                  submission?.positions.firstPolePositionDriver ===
                    group?.drivers.find(
                      (e) => e.result === "secondPolePosition"
                    )?.name ||
                  submission?.positions.firstPolePositionDriver ===
                    group?.drivers.find((e) => e.result === "thirdPolePosition")
                      ?.name
                ) {
                  userStarPoints += 2;
                }
                if (
                  submission?.positions.secondPolePositionDriver ===
                    group?.drivers.find((e) => e.result === "firstPolePosition")
                      ?.name ||
                  submission?.positions.secondPolePositionDriver ===
                    group?.drivers.find(
                      (e) => e.result === "secondPolePosition"
                    )?.name ||
                  submission?.positions.secondPolePositionDriver ===
                    group?.drivers.find((e) => e.result === "thirdPolePosition")
                      ?.name
                ) {
                  userStarPoints += 2;
                }
                if (
                  submission?.positions.thirdPolePositionDriver ===
                    group?.drivers.find((e) => e.result === "firstPolePosition")
                      ?.name ||
                  submission?.positions.thirdPolePositionDriver ===
                    group?.drivers.find(
                      (e) => e.result === "secondPolePosition"
                    )?.name ||
                  submission?.positions.thirdPolePositionDriver ===
                    group?.drivers.find((e) => e.result === "thirdPolePosition")
                      ?.name
                ) {
                  userStarPoints += 2;
                }
                if (
                  submission?.positions.fourthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fourthPlace")
                      ?.name ||
                  submission?.positions.fourthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fifthPlace")
                      ?.name ||
                  submission?.positions.fourthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "sixthPlace")
                      ?.name ||
                  submission?.positions.fourthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "seventhPlace")
                      ?.name ||
                  submission?.positions.fourthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "eighthPlace")?.name
                ) {
                  userPoints += 1;
                }
                if (
                  submission?.positions.fifthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fourthPlace")
                      ?.name ||
                  submission?.positions.fifthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fifthPlace")
                      ?.name ||
                  submission?.positions.fifthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "sixthPlace")
                      ?.name ||
                  submission?.positions.fifthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "seventhPlace")
                      ?.name ||
                  submission?.positions.fifthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "eighthPlace")?.name
                ) {
                  userPoints += 1;
                }
                if (
                  submission?.positions.sixthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fourthPlace")
                      ?.name ||
                  submission?.positions.sixthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fifthPlace")
                      ?.name ||
                  submission?.positions.sixthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "sixthPlace")
                      ?.name ||
                  submission?.positions.sixthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "seventhPlace")
                      ?.name ||
                  submission?.positions.sixthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "eighthPlace")?.name
                ) {
                  userPoints += 1;
                }
                if (
                  submission?.positions.seventhPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fourthPlace")
                      ?.name ||
                  submission?.positions.seventhPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fifthPlace")
                      ?.name ||
                  submission?.positions.seventhPlaceDriver ===
                    group?.drivers.find((e) => e.result === "sixthPlace")
                      ?.name ||
                  submission?.positions.seventhPlaceDriver ===
                    group?.drivers.find((e) => e.result === "seventhPlace")
                      ?.name ||
                  submission?.positions.seventhPlaceDriver ===
                    group?.drivers.find((e) => e.result === "eighthPlace")?.name
                ) {
                  userPoints += 1;
                }
                if (
                  submission?.positions.eighthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fourthPlace")
                      ?.name ||
                  submission?.positions.eighthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "fifthPlace")
                      ?.name ||
                  submission?.positions.eighthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "sixthPlace")
                      ?.name ||
                  submission?.positions.eighthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "seventhPlace")
                      ?.name ||
                  submission?.positions.eighthPlaceDriver ===
                    group?.drivers.find((e) => e.result === "eighthPlace")?.name
                ) {
                  userPoints += 1;
                }
                if (
                  submission?.positions.fastestLapDriver === group?.fastestLap
                ) {
                  userPoints += 1;
                }
              } else {
                submission?.events?.forEach((event) => {
                  if (
                    event.selectedResult ===
                    group?.events.find(
                      (e) =>
                        e.homeTeam === event.homeTeam &&
                        e.awayTeam === event.awayTeam
                    )?.result
                  ) {
                    if (event.isStarGame) {
                      if (
                        room.leagueName === "NBA" ||
                        room.leagueName === "MLB" ||
                        room.leagueName === "NHL"
                      ) {
                        userStarPoints += 1;
                      } else if (
                        room.leagueName === "NFL" ||
                        room.leagueName === "UFL"
                      ) {
                        userStarPoints += 4;
                      } else {
                        userStarPoints += 6;
                      }
                    } else {
                      if (
                        room.leagueName === "NBA" ||
                        room.leagueName === "MLB" ||
                        room.leagueName === "NHL"
                      ) {
                        userPoints += 0.25;
                      } else if (
                        room.leagueName === "NFL" ||
                        room.leagueName === "UFL"
                      ) {
                        userPoints += 2;
                      } else {
                        userPoints += 3;
                      }
                    }
                  } else if (
                    group?.events.find(
                      (e) =>
                        e.homeTeam === event.homeTeam &&
                        e.awayTeam === event.awayTeam
                    )?.result === "Draw" &&
                    (event.selectedResult === "Home" ||
                      event.selectedResult === "Away")
                  ) {
                    if (event.isStarGame) {
                      userStarPoints += 2;
                    } else {
                      userPoints += 1;
                    }
                  }
                });
              }
            }
          }
        });
      });

      setTotalChampionPoints(userPoints + userStarPoints);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while calculating total champion points");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchTotalChampionPoints();
    }
    // eslint-disable-next-line
  }, [user]);

  const getActiveMembershipTierIcon = (tier) => {
    switch (tier) {
      case "platinum":
        return "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbadges%2FMultiplicador%202x%20Platinum.png?alt=media&token=41617020-aeb0-44dc-9d4f-5c32bc47b9df";
      case "gold":
        return "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbadges%2FMultiplicador%202x%20Gold.png?alt=media&token=90bc68dd-b55c-4ad9-bfd8-5ef9a1a9d192";
      default:
        return null;
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="profilePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("profile").toUpperCase()}
      </h1>
      <img
        alt="bannerImage"
        src={userData?.bannerDesktop}
        style={{ width: "100%", borderRadius: 20 }}
        className="hideOnMobile"
      />
      <img
        alt="bannerImage"
        src={userData?.bannerMobile}
        style={{ width: "100%", borderRadius: 20 }}
        className="hideOnDesktop"
      />
      <div className="underProfileBannerContainer">
        <Avatar
          alt={userData?.displayName || "avatar"}
          src={userData?.avatar}
          size={168}
          user={userData}
          className="underProfileAvatar"
        />
        <div
          className="underProfileBannerTextContainer"
          style={{ marginBottom: "0.5rem", marginLeft: "1.5rem" }}
        >
          {/* Sports Pass feature removed; membership visuals handled by Avatar */}
          <p
            id="accountPageUsername"
            style={{
              color: "#FFFFFF",
              marginBottom: 0,
              fontSize: 32,
              fontWeight: 700,
            }}
          >
            {getActiveMembershipTierIcon(activeMembershipTier) && (
              <img
                alt="badge"
                src={getActiveMembershipTierIcon(activeMembershipTier)}
                style={{
                  width: 50,
                  height: "auto",
                  backgroundColor: "transparent",
                }}
              />
            )}
            {userData?.username}
          </p>
          <div style={{ display: "flex", flexDirection: "row", fontSize: 15 }}>
            <p style={{ color: "#FFFFFF", marginRight: "1rem" }}>
              ⭐ {userData?.starCoins ? userData.starCoins : 0}
            </p>
            <p style={{ color: "#FFFFFF", marginRight: "1rem" }}>
              🏆 {totalChampionPoints ? totalChampionPoints : 0}
            </p>
            <p style={{ color: "#FFFFFF" }}>
              🎟️ {userData?.tickets ? userData.tickets : 0}
            </p>
          </div>
        </div>
      </div>
      <div
        onClick={() => navigate("/account/profile/change-avatar")}
        className="accountPageMenuItem"
      >
        <p>AVATAR</p>
      </div>
      <div
        onClick={() => navigate("/account/profile/change-banner")}
        className="accountPageMenuItem"
      >
        <p>BANNER</p>
      </div>
      <div
        onClick={() => navigate("/account/profile/change-username")}
        className="accountPageMenuItem"
      >
        <p>{t("username").toUpperCase()}</p>
      </div>
      <div
        onClick={() => navigate("/account/profile/user-info")}
        className="accountPageMenuItem"
      >
        <p>{t("userInfo").toUpperCase()}</p>
      </div>
    </div>
  );
}

export default ProfilePage;
